import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-procurement-details',
  templateUrl: './land-procurement-details.component.html',
  styleUrls: ['./land-procurement-details.component.css']
})
export class LandProcurementDetailsComponent implements OnInit {

  title="Land Procurement";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/land-procurement-details/land-procurement-details.component.ts